import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledLandmark } from './BKJLandmark.styled.js';
export const BKJLandmark = forwardRef(({ as, ...rest }, ref) => {
    return _jsx(StyledLandmark, { as: as, ref: ref, ...rest });
});
BKJLandmark.displayName = 'BKJLandmark';
//# sourceMappingURL=BKJLandmark.js.map